import React from 'react';

import FilterChip from './components/filter-chip/filter-chip';

import './filter-chips.scss';

export interface FilterChipValue {
  categoryCode?: string;
  categoryName?: string;
  valueCode?: string;
  valueName?: string;
}

interface FilterChipsProps {
  className?: string;
  filters?: FilterChipValue[];
  onChipClick: (filterChip: FilterChipValue) => void;
  onClearAllClick?: () => void;
  showClearAll?: boolean;
}

function FilterChips(props: FilterChipsProps) {
  const {
    className,
    filters = [],
    onChipClick,
    onClearAllClick,
    showClearAll = false
  } = props;

  return Array.isArray(filters) && filters.length > 0 ? (
    <div
      className={`${className || ''} filter-chips`}
      data-testid="filter-chips"
      styleName="chip-container"
    >
      {filters.map((chip, i) => (
        <FilterChip
          categoryCode={chip.categoryCode}
          categoryName={chip.categoryName}
          key={`crumb-${i}`}
          onClick={onChipClick}
          valueCode={chip.valueCode}
          valueName={chip.valueName}
        />
      ))}
      {showClearAll && filters.length > 1 && (
        <button
          className="filter-chips__clear-all-button"
          onClick={onClearAllClick}
          styleName="clear-all"
        >
          clear all
        </button>
      )}
    </div>
  ) : null;
}

export default React.memo(FilterChips);
